<template>
  <header
    class="flex pl-2 pr-3 bg-white"
    style="padding-top: 0.375rem; padding-bottom: 0.375rem"
    :class="[menuOpen ? 'bg-white' : '', treeOpen && menuOpen ? 'items-start' : 'items-center', !showSearchField && !menuOpen ? 'justify-between' : 'justify-end'].join(' ')"
    data-testid="mobile-nav-head">
    <a v-if="!showSearchField && !menuOpen" v-show="!(treeOpen && menuOpen)" :aria-label="translations?.ariaLabels?.goToStartPage" :href="logoLink" class="flex items-center pt-0 pl-1 lg:pl-4" data-testid="mobileMenuLogoLink">
      <img class="inline" width="111" height="23" src="../../../assets/images/logo-orange.svg" alt="Ellevio logo" data-testid="mobileMenuLogoImage" />
    </a>
    <div v-if="treeOpen && menuOpen">
      <button class="flex items-center px-2 pt-3 pb-2" @click="showMainMenu" @keyup.enter="showMainMenu">
        <svg class="transform rotate-180" width="8" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.585 0L.001 1.584l6.414 6.415L8 6.414 1.585 0zM0 11.204l1.585 1.585L5.36 9.015 3.775 7.429 0 11.204z" fill="#000" />
        </svg>
        <!-- TODO: lang: Huvudmeny-->
        <span class="ml-2">Huvudmeny</span>
      </button>
      <h3 v-if="treeHeadingLink" class="mt-1 mb-2 ml-2" style="font-size: 32px">
        <a :href="treeHeadingLink" class="group">{{ treeHeading }}<ellevio-web-link-icon class="relative w-8 h-8 -top-0.5" /></a>
      </h3>
      <h3 v-if="!treeHeadingLink" class="mt-1 mb-2 ml-2" style="font-size: 32px">
        {{ treeHeading }}
      </h3>
    </div>

    <ul v-if="!showSearchField" class="flex">
      <li v-if="!myPages" tabindex="0" class="flex flex-col items-center p-2 pb-1 cursor-pointer" @keyup.enter="toggleSearchField" @click="toggleSearchField" data-testid="mobileMenuSearchOption">
        <img v-show="!menuOpen" class="inline top-mobile-icons" width="22" height="22" src="../../../assets/images/search-black.svg" alt="search" />
        <span v-show="!menuOpen" class="whitespace-nowrap mt-0.5 uppercase font-futuraEfDemiBold text-[0.6875rem]" :class="!menuOpen && dark ? 'text-white' : 'text-black'">{{ translations?.search?.menuLabel }}</span>
      </li>
      <li v-if="showLogin" tabindex="0" class="flex flex-col items-center p-2 pb-1 cursor-pointer" @keyup.enter="toggleLoginMenu" @click="toggleLoginMenu" data-testid="mobileMenuLoginOption">
        <img v-show="!menuOpen" class="inline top-mobile-icons" width="22" height="22" src="../../../assets/images/login-black.svg" alt="log in" />
        <span v-show="!menuOpen" class="whitespace-nowrap mt-0.5 uppercase font-futuraEfDemiBold w-14 text-center text-[0.6875rem] text-newColors-gray-content" :class="{ 'text-ellipsis overflow-hidden': userLoggedIn }">{{ profileButtonText }}</span>
      </li>
      <li class="flex flex-col items-center pt-2 pb-1 pl-2 pr-0 cursor-pointer lg:p-2" tabindex="0" @click="toggleMenu" @keyup.enter="toggleMenu" @keydown.esc="closeMenu" data-testid="mobileMenuMenuOption">
        <img v-show="menuOpen" width="18" height="18" class="inline top-mobile-icons" src="../../../assets/images/cross-black.svg" alt="close menu" />
        <img v-show="!menuOpen" width="22" height="22" class="inline top-mobile-icons" src="../../../assets/images/menu-black.svg" alt="open menu" />
        <span class="whitespace-nowrap mt-0.5 uppercase font-futuraEfDemiBold text-[0.6875rem]" :class="!menuOpen && dark ? 'text-white' : 'text-black'">{{ translations?.topMenuMobile.menuLabel }}</span>
      </li>
    </ul>
  </header>
</template>

<script>
import EllevioWebLinkIcon from '../structure/LinkIcon.vue'
//import EllevioWebSearchInput from '../vue-components/SearchInput.vue'

export default {
  name: 'EllevioWebMobileNavHead',
  components: {
    EllevioWebLinkIcon
    //EllevioWebSearchInput
  },
  props: {
    loginMenu: {
      type: Object,
      default: () => {}
    },
    translations: {
      type: Object,
      default: () => {}
    },
    logoLink: {
      type: String,
      default: '/'
    },
    menuOpen: {
      type: Boolean,
      default: false
    },
    treeOpen: {
      type: Boolean,
      default: false
    },
    treeHeading: {
      type: String,
      default: ''
    },
    treeHeadingLink: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    showSearchField: {
      type: Boolean,
      default: false
    },
    tagsForSmallerInput: {
      type: Boolean,
      default: false
    },
    myPages: {
      type: Boolean,
      default: false
    },
    showLogin: {
      type: Boolean,
      default: true
    },
    userLoggedIn: {
      type: Boolean,
      default: false
    },
    apiUrl: {
      type: String,
      required: true
    },
    showAutocompleteList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      emptySearchField: false
    }
  },
  computed: {
    profileButtonText: function () {
      if (this.loginMenu?.userName?.length > 0) {
        const userNameSplit = this.loginMenu.userName.split(' ')
        const potentialFirstName = userNameSplit[0]

        return potentialFirstName.length > 10 ? potentialFirstName.substring(0, 10) + '...' : potentialFirstName
      } else return this.loginMenu.heading
    }
  },
  methods: {
    objectEmpty(obj) {
      return typeof obj === 'undefined' || (Object.keys(obj).length === 0 && obj.constructor === Object)
    },
    toggleMenu() {
      this.$emit('toggle-menu')
    },
    closeMenu() {
      this.$emit('close-menu')
    },
    showMainMenu() {
      this.$emit('show-main-menu')
    },
    toggleLoginMenu() {
      this.$emit('toggle-login-menu')
    },
    toggleSearchField() {
      this.$emit('show-search-field')
    },
    closeSearchField() {
      this.emptySearchField = true
      this.$emit('close-search-field')
    }
  }
}
</script>
